export const DeleteProjectModalTranslations = {
  en: {
    deleteProjectModal: {
      title: "Permanently delete?",
      description:
        "You are about to delete this performance and every revision of it. This action is irreversible. Are you sure you want to continue?",
      cancel: "Cancel",
      confirm: "Delete",
    },
  },
  es: {
    deleteProjectModal: {
      title: "¿Eliminar permanentemente?",
      description:
        "Estás a punto de eliminar esta hoja de performance y todas sus revisiones. Esta acción es irreversible. ¿Estás seguro de que deseas continuar?",
      cancel: "Cancelar",
      confirm: "Eliminar",
    },
  },
};
